export default {"src":"/_next/static/media/tray-icon.bd54b608.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};